import { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { MisplacedBrokerModal } from 'Components/Common/Modal';
import { Brokers } from 'Services';

// Redux
import { useSelector } from 'react-redux';

// Images
import Logo from 'Assets/images/logo.png';

export default ({ onBrokerSelect, availableBrokers, ...props }) => {
  const [brokers, setBrokers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const getBrokers = async () => {
      setIsLoading(true);
      try {
        setBrokers(await Brokers.getActiveBrokers(user.id));
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (availableBrokers) setBrokers(availableBrokers);
    else getBrokers();
  }, [availableBrokers, user.id]);

  const handleBrokerClick = () => {
    MisplacedBrokerModal();
  };

  return (
    <Modal {...props} size="md" centered className="brokers-list-modal" animation={false}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <img src={Logo} alt="logo" className="logo" />
        {isLoading ? (
          <div>
            <Spinner animation="border" size="lg" className="mt-5" />
          </div>
        ) : (
          <>
            <p className="color-white mt-3">Please select your Broker </p>
            {brokers.map((broker) => (
              <div className="box-wrapper" key={broker.id} onClick={() => onBrokerSelect(broker)} role="button" tabIndex={0}>
                <img src={broker.avatar_url} alt="icon" />
                <span className="name">{broker.name}</span>
              </div>
            ))}
            <Button className="mt-2" onClick={handleBrokerClick}>
              Don’t See Your Broker?
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};
